import { makeStyles, tokens } from '@fluentui/react-components';
import { APPROVED_COLOR, DENIED_COLOR } from '../constants/table';

export const useChangeHistoryPageStyles = makeStyles({
  pageRoot: {
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
  },
  header: {
    display: 'flex',
    flexDirection: 'column',
    gap: '4px',
    marginBottom: '16px',
  },
  subtitleRow: {
    display: 'flex',
    alignItems: 'center',
    gap: '24px',
    flexWrap: 'wrap',
  },
  lastUpdated: {
    display: 'flex',
    alignItems: 'center',
    gap: '6px',
    color: tokens.colorNeutralForeground3,
  },

  // Filters
  exportRow: {
    display: 'flex',
    alignItems: 'center',
    padding: '4px 0',
    borderBottom: `1px solid ${tokens.colorNeutralStroke2}`,
    marginBottom: '12px',
  },
  filtersRow: {
    display: 'flex',
    alignItems: 'flex-end',
    gap: '16px',
    marginBottom: '20px',
    flexWrap: 'wrap',
  },
  filterGroup: {
    display: 'flex',
    flexDirection: 'column',
    gap: '4px',
  },
  filterLabel: {
    fontSize: '12px',
    fontWeight: 600,
    color: tokens.colorNeutralForeground3,
  },

  // Table
  tableWrapper: {
    overflowX: 'auto' as const,
    overflowY: 'auto' as const,
    width: '100%',
    flex: 1,
    minHeight: '200px',
    scrollbarWidth: 'thin' as const,
  },

  // Type column
  type: {
    display: 'flex',
    alignItems: 'center',
    gap: '6px',
  },
  typePromotion: {
    color: APPROVED_COLOR,

  },
  typeDemotion: {
    color: DENIED_COLOR,
  },

  // Partner link
  partnerLink: {
    color: tokens.colorBrandForegroundLink,
    fontWeight: 'normal',
    cursor: 'pointer',
    textDecoration: 'none',
    ':hover': {
      textDecoration: 'underline',
    },
  },

  // Contract status badges
  badgeDmp: {
    backgroundColor: tokens.colorBrandBackground,
    color: tokens.colorNeutralForegroundOnBrand,
    fontSize: '11px',
    fontWeight: 600,
    padding: '2px 8px',
    borderRadius: '4px',
  },
  badgeAdr: {
    backgroundColor: tokens.colorPaletteGreenBackground3,
    color: tokens.colorNeutralForegroundOnBrand,
    fontSize: '11px',
    fontWeight: 600,
    padding: '2px 8px',
    borderRadius: '4px',
  },

  // Status badges
  statusApproved: {
    color: tokens.colorPaletteGreenForeground1,
    fontWeight: 600,
  },
  statusDenied: {
    color: tokens.colorPaletteRedForeground1,
    fontWeight: 600,
  },

  messageBarWrapper: {
    marginBottom: '16px',
  },
  emptyState: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '40px',
    color: tokens.colorNeutralForeground3,
  },

  // Notes icon
  notesIcon: {
    color: tokens.colorPaletteYellowForeground1,
    cursor: 'pointer',
  },
  dash: {
    color: tokens.colorNeutralForeground3,
  },
});
